import { c as _c } from "react/compiler-runtime";
import type { HofDashboardDeadline } from '@/features/hof-dashboard/api/hof-dashboard-data';
import { formatDate, formatTimeLeft, translate } from '@/features/hof-dashboard/texts';
import { daysUntil } from '@/features/hof-dashboard/utils/submission-progress';
import type { Locale } from '@/types/types';
import { cn } from '@/utils/tailwindcss-override';
import type React from 'react';

/** Deadlines, soonest first, with the passed ones set back in grey. */
export const DeadlineList: React.FC<{
  deadlines: Pick<HofDashboardDeadline, 'id' | 'date' | 'title'>[];
  locale: Locale;
}> = t0 => {
  const $ = _c(12);
  const {
    deadlines,
    locale
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== deadlines || $[1] !== locale) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const now = new Date();
      if (deadlines.length === 0) {
        let t4;
        if ($[5] !== locale) {
          t4 = translate("noDeadlines", locale);
          $[5] = locale;
          $[6] = t4;
        } else {
          t4 = $[6];
        }
        let t5;
        if ($[7] !== t4) {
          t5 = <p className="text-sm text-gray-500">{t4}</p>;
          $[7] = t4;
          $[8] = t5;
        } else {
          t5 = $[8];
        }
        t3 = t5;
        break bb0;
      }
      t1 = "space-y-3";
      t2 = deadlines.map(deadline => {
        const daysLeft = daysUntil(deadline.date, now);
        const passed = daysLeft < 0;
        return <li key={deadline.id} className="flex gap-4 text-sm"><span className={cn("w-24 shrink-0 font-semibold tabular-nums", passed ? "text-gray-500" : "text-gray-900")}>{formatDate(deadline.date, locale)}</span><span className="min-w-0 flex-1"><span className={cn("block", passed ? "text-gray-500" : "text-gray-900")}>{deadline.title}</span><span className="text-xs text-gray-600">{formatTimeLeft(daysLeft, locale)}</span></span></li>;
      });
    }
    $[0] = deadlines;
    $[1] = locale;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2) {
    t4 = <ol className={t1}>{t2}</ol>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};